import React from 'react';

const ABOUT_PARAGRAPHS = [
  "I'm Raghav, a software developer. I love to code, and I love watching things move, break, and eventually work. This site is a collection of some cool stuff, some questionable experiments, and a few things that exist purely because I wanted to build them.",
  "I started out as a Mechanical Engineering student at BITS Pilani, but at some point I realised I was spending more time reading tech and coding than learning stress-strain curves. Since then, I've been building anything and everything, from implementing ML models and python scripts to full-stack apps and websites, and learning how systems work.",
  "I enjoy the entire journey-from \"this should be easy\" to \"why is this not working\" to \"oh wow, that finally works.\" I care about clean code, solid architecture, and that small dopamine hit when a feature works exactly the way it should.",
  "In fact, the idea of building this site and putting everything online was simply to know if I can point some DNS records, letting requests traverse the internet, resolve through CDNs, and render cleanly in a browser somewhere, and then see how it goes.",
];

const ABOUT_CLOSING = "And if you're reading this, it worked and it's going pretty well *wink wink*.";

export default function About() {
  return (
    <section id="about" className="panel">
      <h3>About</h3>
      {ABOUT_PARAGRAPHS.map((paragraph) => (
        <p key={paragraph.substring(0, 30)}>{paragraph}</p>
      ))}
      <p><em>{ABOUT_CLOSING}</em></p>
    </section>
  );
}

